import TransferToOrder from '@components/TransferToOrder';
import { notifications } from '@utils/notifications';
import { observer } from 'mobx-react';

import {
  MiniCartEmptyCart,
  MiniCartGifts,
  MiniCartHeader,
  MiniCartInfo,
  MiniCartProducts,
  MiniCartServices
} from './components';
import LoadingPage from '@components/LoadingPage';
import './index.scss';
import { useStores } from '@root/src/stores';
// import PrizotekaBanner2025 from '@routes/Prizoteka2025/PrizotekaBanner2025';

const MiniCart = observer(({ isShow, hideMiniCart }) => {
  const { cartStore } = useStores();
  const {
    cart,
    specialPrice,
    productsAmountMultiple,
    updateCart,
    isCartEmpty,
    isLoadCart,
    clearCart,
    cartItemsCount
  } = cartStore;

  const removeProduct = item => {
    updateCart(item.product.id, 0, item.id);
  };

  const removeService = service => {
    cartStore.removeService(service);
    notifications('Услуга удалена из корзины!', '');
  };

  return (
    <div className={`mini-cart${isShow ? '' : ' mini-cart--hide'}`}>
      {isLoadCart ? (
        <>
          <TransferToOrder type='miniCart' />
          {isCartEmpty ? (
            <>
              <MiniCartEmptyCart hideMiniCart={hideMiniCart} />
              {/* <div className='w-full mt-4'>
              <PrizotekaBanner2025 isCart className='pl-[7.5rem] text-xs' />
            </div> */}
            </>
          ) : (
            <div className='mini-cart__content-wrapper'>
              <MiniCartHeader
                cartNumber={cart.id}
                clearCart={clearCart}
                cartItemsCount={cartItemsCount}
              />
              <div className='mini-cart__lists-wrapper custom-scroll'>
                {!!cart?.items?.length && (
                  <MiniCartProducts
                    products={cart.items}
                    specialPrice={specialPrice}
                    productsAmount={productsAmountMultiple}
                    removeProduct={removeProduct}
                  />
                )}
                {!!cart.services?.length && (
                  <MiniCartServices
                    cartItemsCount={cartItemsCount}
                    removeService={removeService}
                    services={cart.services}
                  />
                )}
                {!!cart.gifts?.length && <MiniCartGifts gifts={cart.gifts} />}
              </div>
              {/* <div className='w-full my-4'>
              <PrizotekaBanner2025 isCart className='pl-[7.5rem] text-xs' />
            </div> */}
              <MiniCartInfo
                cartItemsCount={cartItemsCount}
                subtotal={cart.subtotal}
                hideMiniCart={hideMiniCart}
              />
            </div>
          )}
        </>
      ) : (
        <LoadingPage fullHeight />
      )}
    </div>
  );
});

export default MiniCart;
